import { render, staticRenderFns } from "./TheNavigationBase.vue?vue&type=template&id=0c5de5c0"
import script from "./TheNavigationBase.vue?vue&type=script&lang=ts"
export * from "./TheNavigationBase.vue?vue&type=script&lang=ts"
import style0 from "./TheNavigationBase.vue?vue&type=style&index=0&id=0c5de5c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports